import React from 'react';
import classnames from 'classnames';
import styles from './IconedRadioGroup.module.scss';

// Blueprint 5 не отдаёт isElementOfType наружу — проверка та же самая:
// сравнение типа элемента с компонентом
const isIconedRadio = (child: React.ReactNode): child is React.ReactElement<IconedRadioProps> =>
    React.isValidElement(child) && child.type === IconedRadio;

export const IconedRadio: React.FC<IconedRadioProps> = (props) => {
    const { inline, name, value, checked, label, onChange, children } = props;

    const className = classnames({
        'bp5-control bp5-radio': true,
        'bp5-inline': !!inline
    });

    return (
        <label className={className}>
            <input name={name} type="radio" value={value} checked={checked} onChange={() => onChange && onChange(value || '')} />
            <span className={`${styles.indicator} control-indicator`} title={label}>
                {children}
            </span>
        </label>
    );
};

(IconedRadio as any).displayName = 'IconedRadio';

export const IconedRadioGroup: React.FC<IconedRadioGroupProps> = (props) => {
    const getRadioProps = (optionProps: IconedRadioProps) => {
        const { name, onChange, inline } = props;
        const { className, disabled, value, label } = optionProps;

        return {
            label,
            checked: value === props.selectedValue,
            className,
            disabled: disabled || props.disabled,
            inline,
            name,
            onChange,
            value
        };
    }

    const renderChildren = () => {
        return React.Children.map(props.children, (child) => {
            if (isIconedRadio(child)) {
                return React.cloneElement(child, getRadioProps(child.props));
            }
            else {
                return child;
            }
        });
    }

    return (
        <div className={`${styles.radio} ${props.className || ''}`}>
            {renderChildren()}
        </div>
    );
};

interface IconedRadioGroupProps {
    name: string;
    onChange?: (value: string) => void;
    selectedValue?: string;
    inline?: boolean;
    disabled?: boolean;
    className?: string;
    children?: React.ReactNode;
}

interface IconedRadioProps {
    label: string;
    name?: string;
    value?: string;
    checked?: boolean;
    disabled?: boolean;
    className?: string;
    inline?: boolean;
    onChange?: (value: string) => void;
    children?: React.ReactNode;
}
